export const ContractProvider = {
    FAD: 3,
    MIFIEL: 2,
    AUTOGRAPH: 1
};
